import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import ChatBubble from "./ChatButtle";
import FeedbackModal from "./FeedbackModal";
import ChatBox from "./ChatBox";
import assistentAPI from "apis/AssistentAPI";
import dayjs from "dayjs";
import "./style.css";

export interface historyItem {
  responseId?: string;
  role: "user" | "assistant";
  content: string;
  time: string;
  feedback?: boolean;
};

export interface feedbackModalProps {
  isOpen: boolean;
  idconsulta?: string;
  pergunta?: string;
  resposta?: string;
  avaliacao?: boolean;
};

function AiAssistent(){
  
  const [ loading, setLoading ] = useState(false);
  const [ isChatOpen, setIsChatOpen ] = useState(false);
  const [ history, setHistory ] = useState<historyItem[]>([]);
  const [ feedbackModal, setFeedbackModal ] = useState<feedbackModalProps>({ isOpen: false });
  const [ isUnavailable, setIsUnavailable ] = useState(false);

  const handleSubmitQuestion = (question: string) => {
    setLoading(true);
    
    setHistory(
      [...history,
        {
          role: "user",
          content: question,
          time: dayjs().format('HH:mm')
        }
      ]
    );

    assistentAPI.question(question, history)
      .then((response) => {

        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(`<body>${response.resposta}</body>`,"text/xml");
        let fieldValue = xmlDoc.getElementsByTagName('resposta')[0].childNodes[0].nodeValue!.slice(1);

        setLoading(false);
        
        setHistory((prevState: any) => 
          [...prevState,
            {
              responseId: response.id,
              role: "assistant",
              content: fieldValue,
              time: dayjs().format('HH:mm')
            }
          ]
        );
      })
      .catch(() => {
        setLoading(false);
        setIsUnavailable(true);
      });
    };

    const handleSubmitFeedback = (comentario: string) => {
      assistentAPI.feedBack({
        idconsulta: feedbackModal.idconsulta!,
        pergunta: feedbackModal.pergunta!,
        resposta: feedbackModal.resposta!,
        avaliacao: feedbackModal.avaliacao!,
        comentario: comentario
      })
      .then(() => {
        let reviewedResponse = history.find(item => item.responseId === feedbackModal.idconsulta);
        reviewedResponse!.feedback = feedbackModal.avaliacao;

        setHistory(history);
        setFeedbackModal({ isOpen: false });
      })
      .catch(() => {
        alert('Não foi possível enviar seu feedback. Tente novamente mais tarde.');
      });
    };

    return(
      <>
        <ChatBubble
          onClick={() => setIsChatOpen(true)}
        />
        <FeedbackModal
          isOpen={feedbackModal.isOpen}
          onClose={() => setFeedbackModal({ isOpen: false })}
          onSubmit={handleSubmitFeedback}
        />
        <ChatBox
          history={history}
          isLoading={loading}
          isChatOpen={isChatOpen}
          onSubmitQuestion={handleSubmitQuestion}
          onOpenFeedbackModal={setFeedbackModal}
          onClose={() => setIsChatOpen(false)}
        />
        <Dialog
          open={isUnavailable}
          onClose={() => setIsUnavailable(false)}
          sx={{ zIndex: 10001 }}
        >
          <DialogTitle>Assistente indisponível</DialogTitle>
          <DialogContent>
            <DialogContentText>
              O assistente de IA está indisponível no momento. Tente novamente
              mais tarde.
            </DialogContentText>
            <DialogContentText sx={{ mt: 2 }}>
              Você também pode falar com nosso suporte pelo WhatsApp{" "}
              <strong style={{ whiteSpace: "nowrap" }}>(31) 9528-3733</strong>.
              <br />
              <br />
              Para mais informações, acesse a tela{" "}
              <Link
                to="/suporte"
                onClick={() => {
                  setIsUnavailable(false);
                  setIsChatOpen(false);
                }}
              >
                <strong>Suporte ao Cliente</strong>
              </Link>
              .
            </DialogContentText>
        </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsUnavailable(false)}>Fechar</Button>
          </DialogActions>
        </Dialog>
      </>
    )
};
export default AiAssistent;